import { Property, TypeKind, UnionType } from '../types.js';
import { ModelSystemProperties } from '../internal/ModelSystemProperties.js';
export const ROOT_PROPERTY = '$';
export var SourceType;
(function (SourceType) {
    SourceType[SourceType["Single"] = 0] = "Single";
    SourceType[SourceType["ListCommon"] = 1] = "ListCommon";
    SourceType[SourceType["ListCommonElement"] = 2] = "ListCommonElement";
    SourceType[SourceType["ListCommonForNested"] = 3] = "ListCommonForNested";
    SourceType[SourceType["ListCommonForNestedElement"] = 4] = "ListCommonForNestedElement";
    SourceType[SourceType["ListSpecific"] = 5] = "ListSpecific";
})(SourceType || (SourceType = {}));
export function pathToRoot(propertyValue, keepRoot = true) {
    let path = [propertyValue.property.name];
    let parent = propertyValue.parent;
    while (parent) {
        if (!keepRoot && parent.property.name === '$')
            break;
        path.push(parent.property.name);
        parent = parent.parent;
    }
    return path.reverse().join('.');
}
export class PropertyPathWalker {
    constructor(propertyPath, schema, model, type) {
        this.propertyPath = propertyPath;
        this.schema = schema;
        this.step = 0;
        this.propertyNames = propertyPath.split('.');
        this.currentPropertyValue = { value: model, property: new Property(ROOT_PROPERTY, type) };
    }
    getPropertyValue() {
        let lastPropertyValue = undefined;
        while (true) {
            let tmp = this.next();
            if (tmp) {
                lastPropertyValue = tmp;
            }
            else {
                return lastPropertyValue;
            }
        }
    }
    next() {
        if (this.propertyNames.length <= this.step || !this.currentPropertyValue) {
            return;
        }
        let currentPropertyName = this.propertyNames[this.step];
        let currentType = this.schema.getType(this.currentPropertyValue.property.type);
        let currentProperty;
        if (currentType instanceof UnionType) {
            const types = currentType.types;
            const originValue = this.currentPropertyValue.parent.value[this.currentPropertyValue.property.name];
            const runtimeTypeRef = ModelSystemProperties.getTypeRef(originValue);
            if (!runtimeTypeRef) {
                throw new Error(`Cannot determine runtime type of ${currentType.name}. Try to use Options`);
            }
            const runtimeType = this.schema.getType(runtimeTypeRef);
            if (!types.find(t => t === runtimeType.name)) {
                throw new Error(`Type '${runtimeType.name}' is not in a list of ${currentType.name} union`);
            }
            this.currentPropertyValue.property = Object.assign(Object.assign({}, this.currentPropertyValue.property), { type: runtimeType.name });
            currentType = runtimeType;
        }
        switch (currentType.kind) {
            case TypeKind.Object:
                currentProperty = currentType.getProperty(currentPropertyName);
                break;
            case TypeKind.List: {
                let elementType = this.schema.getType(currentType.elementType);
                let elementIndex = Number.parseInt(currentPropertyName);
                if (Number.isNaN(elementIndex)) {
                    if (elementType.kind !== TypeKind.Object) {
                        throw new Error('Cannot go deeper inside list which doesn\'t contain objects');
                    }
                    currentProperty = elementType.getProperty(currentPropertyName);
                }
                else {
                    currentProperty = new Property(currentPropertyName, elementType.getTypeReference(), {});
                }
            }
        }
        if (currentProperty) {
            this.currentPropertyValue = {
                value: this.currentPropertyValue.value ? this.currentPropertyValue.value[currentPropertyName] : undefined,
                property: currentProperty,
                parent: this.currentPropertyValue
            };
        }
        else {
            this.currentPropertyValue = undefined;
        }
        this.step++;
        return this.currentPropertyValue;
    }
}
//# sourceMappingURL=PropertyPathWalker.js.map